export class SocketChannels {
  public static readonly WAREHOUSE = 'warehouse/';
}
